import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import ProjectShowcase from "./ProjectShowcase";
import { trackAction } from "./PageAnalytics";
import { moreWork, showcases } from "../../data/homepage";
import { workCount } from "../../data/workIndex";

// The four selected projects, stacked in the order set in data/homepage.js,
// each with the same gallery and caption. The hero already offers all the
// work, so the way on to /work here is the card that closes the section: a
// glimpse of the other pieces fading out under a "See all work" pill that
// says how much else is there and of what kind. Only the first gallery loads
// eagerly; it is the one inside the first screen.

function MoreWork() {
  return (
    <Link
      to="/work"
      className="pf-more"
      onClick={() => trackAction("open_work", "selected-work:end")}
    >
      <span className="pf-more__window" aria-hidden="true">
        <span className="pf-more__grid">
          {moreWork.map((piece) => (
            <img
              key={piece.area}
              className={`pf-more__piece pf-more__piece--${piece.area}`}
              src={piece.src}
              width={piece.size[0]}
              height={piece.size[1]}
              alt=""
              loading="lazy"
              decoding="async"
            />
          ))}
        </span>
      </span>
      <span className="pf-more__label">
        <span className="pf-pill pf-more__pill">
          See all work
          <ArrowRight size={16} strokeWidth={1.75} aria-hidden="true" />
        </span>
        <span className="pf-more__meta">
          {workCount} projects, including interfaces and motion studies
        </span>
      </span>
    </Link>
  );
}

function SelectedWork() {
  return (
    <section
      id="selected-work"
      tabIndex={-1}
      className="pf-section pf-section--work pf-shell"
      aria-labelledby="selected-work-heading"
    >
      <div className="pf-section__head">
        <h2 id="selected-work-heading" className="pf-section__title">
          Selected work
        </h2>
      </div>
      <div className="pf-showcases">
        {showcases.map((project, index) => (
          <ProjectShowcase key={project.id} project={project} priority={index === 0} />
        ))}
      </div>
      <MoreWork />
    </section>
  );
}

export default SelectedWork;
